module.exports = __webpack_public_path__ + "img/short-term-dormant-months-free.c3c70276.png";